import { boolean, object, string, InferType } from 'yup'

export const UserType = {
  EMPLOYEE: 'employee',
  CUSTOMER: 'customer',
  SUBSCONTRACTOR: 'subcontractor'
}

export const RolesMap = {
  ADMIN_ROLE: 'admin',
  EMPLOYEE_ROLE: 'employee',
  SALES_ROLE: 'sales',
  PROJECT_MANAGER_ROLE: 'project_manager',
  ESTIMATOR_ROLE: 'estimator',
  FINANCE_ROLE: 'finance',
  SUBCONTRACTOR_ROLE: 'subcontractor',
  CUSTOMER_ROLE: 'customer'
}

export const UserSchema = object().shape({
  id: string().nullable(),
  name: string().nullable(),
  email: string().nullable().when('$isEmailString', (isEmailString, schema) => isEmailString ? schema.email() : schema),
  phone: string().nullable(),
  roles: object<Record<string, boolean>>().nullable(),
  verified: boolean().nullable(),
  avatar: string().url().optional(),
  hubspotId: string().optional(),
  address: string().optional(),
  billing: string().optional(),
  type: string().oneOf(Object.values(UserType)).optional()
})

export type User = InferType<typeof UserSchema>

export class UserClass implements User {
  id: string  = null
  name: string = null
  email: string = null
  phone: string = null
  avatar: string = null
  roles: Record<string, boolean> = {}
  verified: boolean = false
  hubspotId: string = null
  address: string = null
  billing: string = null
  type: string = null

  constructor(data: Partial<User> = {}) {
    Object.assign(this, data)
  }
}
